import { useTranslation } from 'react-i18next';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import CreateEditDayLimitArrangementsForm from './components/form/CreateEditDayLimitArrangementsForm';
import useDeleteDayLimitArrangement from './hooks/useDeleteDayLimitArrangement';
import { useGetColumnDefs } from './hooks/useGetColumnDefs';
import { useGetDayLimitArrangements } from 'queries';

const DayLimitArrangements = () => {
  const { t } = useTranslation('common');
  const { data, isFetching } = useGetDayLimitArrangements();
  const columns = useGetColumnDefs();
  const deleteMutation = useDeleteDayLimitArrangement();

  // DataGrid passes an array of selected ids for bulk delete; ensure single id payload
  const onDeleteClick = (ids: string[]) => {
    deleteMutation.mutate({ id: ids[0] });
  };

  return (
    <TableCRUDLayout
      FormComponent={CreateEditDayLimitArrangementsForm}
      drawerWidth={500}
      rows={data}
      loading={isFetching}
      columns={columns}
      getRowId={(row) => row.id}
      onDeleteClick={onDeleteClick}
      confirmationTitle={t('dayLimitArrangements.confirmationTitle')}
      confirmationBody={t('dayLimitArrangements.confirmationBody')}
      customCreateTitle={t('dayLimitArrangements.createTitle')}
      customEditTitle={t('dayLimitArrangements.editTitle')}
    />
  );
};
export default DayLimitArrangements;
